"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _reactAddonsPureRenderMixin = _interopRequireDefault(require("react-addons-pure-render-mixin"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _UIAlert = _interopRequireDefault(require("UIComponents/alert/UIAlert"));

var _UISettings = _interopRequireDefault(require("composer-lib/data/model/UISettings"));

var _default = (0, _createReactClass.default)({
  displayName: "GoogleErrorAlert",
  mixins: [_reactAddonsPureRenderMixin.default],
  propTypes: {
    dismissGoogleAuthError: _propTypes.default.func.isRequired,
    dismissGoogleDocImportError: _propTypes.default.func.isRequired,
    dismissGoogleDocImportImageUploadError: _propTypes.default.func.isRequired,
    uiSettings: _propTypes.default.instanceOf(_UISettings.default).isRequired
  },
  getBaseLangKey: function getBaseLangKey() {
    if (this.props.uiSettings.showGoogleAuthError) {
      return 'googleAuthError';
    } else if (this.props.uiSettings.showGoogleDocImportImageUploadError) {
      return 'googleDocImportImageUploadError';
    }

    return 'googleDocImportError';
  },
  getCloseCallback: function getCloseCallback() {
    if (this.props.uiSettings.showGoogleAuthError) {
      return this.props.dismissGoogleAuthError;
    } else if (this.props.uiSettings.showGoogleDocImportImageUploadError) {
      return this.props.dismissGoogleDocImportImageUploadError;
    }

    return this.props.dismissGoogleDocImportError;
  },
  langKey: function langKey(key) {
    return "composer-lib.alerts." + this.getBaseLangKey() + "." + key;
  },
  render: function render() {
    var _this$props$uiSetting = this.props.uiSettings,
        showGoogleAuthError = _this$props$uiSetting.showGoogleAuthError,
        showGoogleDocImportError = _this$props$uiSetting.showGoogleDocImportError,
        showGoogleDocImportImageUploadError = _this$props$uiSetting.showGoogleDocImportImageUploadError;

    if (!(showGoogleAuthError || showGoogleDocImportError || showGoogleDocImportImageUploadError)) {
      return null;
    }

    var className = (0, _classnames.default)('google-auth-error', {
      small: showGoogleDocImportError
    });
    return _react.default.createElement(_UIAlert.default, {
      className: className,
      closeable: true,
      onClose: this.getCloseCallback(),
      titleText: _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('title')
      }),
      type: "danger"
    }, _react.default.createElement(_FormattedMessage.default, {
      message: this.langKey('body')
    }));
  }
});

exports.default = _default;
module.exports = exports.default;